// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ZAnS","newExpiryDate":"styles_newExpiryDate__2xDCk","footer":"styles_footer__2hDf9"};